<div class="button-grid">
  <div class="button-grid__item">
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'sack-dollar']"
      [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToMoneyClosing()">
      {{ "webPos.Closings.MoneyButton" | translate}}
    </app-card-button>
  </div>
  <div class="button-grid__item">
    <app-card-button [disabled]="false" [buttonSize]="CardButtonSize.Long"
      [buttonIcon]="['fas', 'ticket']" [buttonBackground]="CardButtonBackground.Tertiary"
      (clicked)="goToValuablesClosing()">
      {{ "webPos.Closings.ValuablesShort" | translate}}
    </app-card-button>
  </div>

</div>
